import { type CSSProperties } from 'react';
import { kebabCase } from 'es-toolkit';

export const commonLinkStyles: CSSProperties = {
  animation: 'none',
  border: 'none',
  position: 'relative',
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: '50%',
  margin: '8px auto',
  display: 'inline-flex',
  flexWrap: 'wrap',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  rowGap: '0px',
  float: 'none',
  opacity: '1',
  transform: 'translateX(-50%)',
  zoom: '1',
  visibility: 'visible',
  boxSizing: 'border-box',
  fontFamily: 'Roboto,Arial,Sans-serif',
  textAlign: 'left',
  textDecoration: 'none',
  maxWidth: '400px',
  textIndent: '0'
};

export const buttonModeLinkStyles: CSSProperties = {
  backgroundColor: 'rgba(238, 238, 238, 0.9)',
  color: 'rgba(17, 17, 17, 0.5)',
  padding: '4px 12px 4px 6px',
  height: '24px',
  columnGap: '5px',
  lineHeight: '14px',
  fontSize: '12px',
  fontWeight: '600',
  borderRadius: '40px'
};

export const textModeLinkStyles: CSSProperties = {
  backgroundColor: 'transparent',
  height: '14px',
  columnGap: '8px',
  lineHeight: 1.27,
  fontWeight: '500',
  textAlign: 'center'
};

export const commonLinkIconStyles: CSSProperties = {
  display: 'block',
  fill: 'currentColor'
};

export const buttonModeLinkIconStyles: CSSProperties = {
  width: '16px',
  height: '16px'
};

export const textModeLinkIconStyles: CSSProperties = {
  width: '14px',
  height: '14px',
  marginRight: '-4px'
};

export const removeButtonStyles: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  width: '20px',
  height: '20px',
  overflow: 'hidden',
  position: 'absolute',
  right: '-9px',
  top: '-9px',
  background: '#f93262'
};

export const removeButtonIconStyles: CSSProperties = {
  display: 'block',
  width: '12px',
  height: '12px',
  fill: '#fff'
};

export const removeTextStyles: CSSProperties = {
  textDecoration: 'underline'
};

export const removeTextForceTwoLinesStyles: CSSProperties = {
  width: '100%',
  height: '100%'
};

export function markStylesImportant(objStyles: CSSProperties) {
  return Object.fromEntries(
    Object.entries(objStyles).map(([key, value]) => [key, `${value}!important`])
  );
}

export function toInlineStyles(style: CSSProperties) {
  return Object.entries(style)
    .map(([key, value]) => `${kebabCase(key)}:${value}`)
    .join(';');
}

export function setStyleAttribute(
  el: SVGSVGElement | HTMLElement | null,
  style: CSSProperties
) {
  if (el) {
    el.setAttribute('style', toInlineStyles(markStylesImportant(style)));
  }
}
